export const AGREEMENT_TYPE = {
  TERMS_AND_CONDITIONS: "terms-and-conditions",
  PRIVACY_POLICY: "privacy-policy",
} as const;

export type AgreementType = typeof AGREEMENT_TYPE[keyof typeof AGREEMENT_TYPE];
